import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features18.css'

const Features18 = (props) => {
  return (
    <div className="features18-layout349 thq-section-padding">
      <div className="features18-max-width thq-section-max-width">
        <div className="features18-content1">
          <div className="features18-section-title">
            <div className="features18-content2">
              <h2>
                {props.feature1Title ?? (
                  <Fragment>
                    <h2 className="features18-text4 thq-heading-2">
                      AI entrepreneurship Make-A-Thon
                    </h2>
                  </Fragment>
                )}
              </h2>
              <p>
                {props.feature1Description ?? (
                  <Fragment>
                    <p className="features18-text3 thq-body-large">
                      The Make-A-Thon is a unique initiative in collaboration
                      with the Commonwealth and OpenWeaver aims to build the AI
                      research, capacity data and infrastructure environment for
                      the stakeholders in the Commonwealth including youths,
                      women and anyone interested in a no code or low-code
                      environment. The package provides for education and
                      capacity to ensure that participants develop practical and
                      industry-ready solutions for scaling up. In the long term,
                      this will have a multiplier impact on Commonwealth
                      economies by changes in education, economy, and
                      employment. This is available for women MSMEs to learn
                      practical digital solution building, develop applications
                      and then scale their business. They will also be provided
                      with free cloud credits for three years. Open Weaver will
                      provide USD 4 million in cloud credits for three years.
                    </p>
                    <span>
                      <a
          href="https://thecommonwealth.org/news/get-involved-digital-consumer-digital-creator-open-weaver"
          target="_blank"
          rel="noopener noreferrer"
          className="initiatives-link thq-body-large"
        >
          <h5>Learn More...</h5>
        </a></span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="features18-image-container">
        <video
    src="/video5.mp4"
    title={props.feature1VideoTitle}
    className="features18-video"
    controls
    allowFullScreen
  >
    Your browser does not support the video tag.
  </video>
        </div>
      </div>
    </div>
  )
}

Features18.defaultProps = {
  feature1Description: undefined,
  feature1VideoTitle: 'AI Entrepreneurship Make-A-Thon Video',
  feature1Title: undefined,
}

Features18.propTypes = {
  feature1Description: PropTypes.element,
  feature1VideoTitle: PropTypes.string,
  feature1Title: PropTypes.element,
}

export default Features18
